import { Component, Input, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { TealiumService } from 'src/app/services/tealium.service';
import { TYPE } from '../../../constants/software-button-var';

@Component({
    selector: 'app-ssangyong-my-downloads',
    templateUrl: './ssangyong-my-downloads.component.html',
    styleUrls: ['./ssangyong-my-downloads.component.less'],
    standalone: false
})
export class SsangyongMyDownloadsComponent implements OnInit {

  downloadUrlData: {
    ID: number,
    PACKAGE_ID: number,
    NAME: string,
    URL_DESC: string
  }[] = [];
  oemName!: string;
  @Input() package: any;
  @Input() selectedSeriesName = "";
  @Input() formDataDropDown: any;
  downloadPopupToggle = false;
  popupDisplayData = {};
  selectedLocaleDeutsch!: boolean;
  selectedLocaleFrancais!: boolean;

  constructor(
    private dataService: DataService,
    private translate: TranslateService,
    private tealiumService: TealiumService
  ) {
    this.checkLocaleForDownloadButtonStyle();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.package = [];
      this.checkLocaleForDownloadButtonStyle();
    });
  }

  ngOnInit(): void {
    this.oemName = this.dataService.getOemName();
  }

  getUrlData(id: number, name: string, version: string, size?: string) {
    this.downloadUrlData = [];
    this.downloadUrlData = this.dataService.getUrlMapData(id);
    this.popupDisplayData = {
      mapName: name,
      mapVersion: version
    }
    this.downloadPopupToggle = true;
    this.tealiumService.trackEvent({
      event_name: 'navshop_click',
      click_text: this.tealiumService.identificationOfMapOrSoftwareDownloads(name, TYPE.BUTTON),
      map_name: name,
      map_version: version,
      map_size: size,
      car_brand: this.formDataDropDown.car_brand,
      car_model: this.formDataDropDown.car_model
    });
  }

  checkLocaleForDownloadButtonStyle() {
    if (this.translate.currentLang.includes('de_DE')) {
      this.selectedLocaleDeutsch = true;
    } else if (this.translate.currentLang.includes('fr_FR')) {
      this.selectedLocaleFrancais = true;
    } else {
      this.selectedLocaleDeutsch = false;
      this.selectedLocaleFrancais = false;
    }
  }

  closePopup(e: any) {
    this.downloadPopupToggle = e;
  }
}